<template>
  <div class="radio-list">
    <label v-if="getTitle" class="label">
      {{ getTitle }}

      <w-tooltip v-if="tooltipContent && tooltipContent.length">{{ tooltipContent }}</w-tooltip>
    </label>

    <div v-for="(item, index) in values" :key="item.value" class="radio">
      <div class="custom-control custom-radio" :for="sid + index">
        <input
          type="radio"
          class="custom-control-input"
          :class="{'is-invalid': model.$error}"
          :id="sid + index"
          :checked="item.value === model.$model"
          :disabled="disabled"
          :name="model.$form.testPath ? model.$path : undefined"
          :value="item.value"
          @change="onInput($event)"
          @focus="onFocus($event)"
          @blur="onBlur($event)"
        />

        <label class="custom-control-label" :for="sid + index" v-html="item.text" />
      </div>
    </div>

    <div v-if="otherLabel">
      <label class="custom-control custom-radio">
        <input
          type="radio"
          class="custom-control-input"
          :class="{'is-invalid': model.$error}"
          :id="sid"
          :checked="otherIsClicked"
          :disabled="disabled"
          @change="onInputOther($event)"
          :name="model.$form.testPath ? model.$path : undefined"
        />

        <label class="custom-control-label" v-show="!otherIsClicked" v-html="otherLabel" :for="sid" />

        <input
          v-show="otherIsClicked"
          class="form-control"
          ref="input"
          :class="{
            borderless: borderless,
            'text-right': model.$schema.type == 'number' || model.$schema.type == 'money' || model.$schema.type == 'integer',
            'is-invalid': model.$error
          }"
          :name="model.$form.testPath ? model.$path : undefined"
          :placeholder="otherLabel"
          :value="model.$value"
          @input="onInputText"
          @focus="onFocus($event)"
          @blur="onBlur($event)"
        />
      </label>
    </div>

    <w-error :model="model"></w-error>
  </div>
</template>

<script>
import modelMixin from '../mixins/modelMixin';
import WError from './error.vue';
import WTooltip from './tooltip.vue';

export default {
  name: 'w-radio-list',
  components: {WError, WTooltip},
  mixins: [modelMixin],
  props: {
    values: {
      type: Array,
      default: () => [] // tablice trzeba zwracać przez funkcję
    },
    otherLabel: String,
    inline: Boolean
    // model: Object
  },

  data() {
    return {
      userOther: false,
      sid: 'rlist' + Math.round(Math.random() * 1000000)
    };
  },
  computed: {
    otherIsClicked() {
      if (!this.model.$value) {
        return this.userOther;
      }
      return !this.values.map(x => x.value).includes(this.model.$value);
    }
  },
  methods: {
    onInput(evt) {
      this.userOther = false;
      if (evt.target.checked) {
        this.model.$value = evt.target.value;
      }
    },
    onInputOther(evt) {
      this.userOther = true;
      // console.log('onInputOther', this.model.$path);
      this.model.$value = '';
      this.model.$reset();
      setTimeout(() => {
        this.$refs.input.focus();
      }, 10);
    },
    onInputText(evt) {
      this.userOther = true;

      this.model.$value = evt.target.value;
    },
    onBlur(evt) {
      this.model.$hasFocus = false;
      this.$emit('blur', evt);
    },
    onFocus(evt) {
      this.model.$hasFocus = true;

      this.$emit('focus', evt);
    }
  }
};
</script>
